/**
 * normNaam.js
 * Gedeelde naam-normalisatie voor browser (Startlijst.jsx) én Node.js (gen-eilanders-lib.js).
 * Geen externe dependencies, geen Node.js-specifieke imports.
 *
 * Fase 1: deterministisch — diacrieten, encoding, komma-notatie, tussenvoegsel
 */

const ENCODING_MAP = {
  'Ã©': 'e', 'Ã¶': 'o', 'Ã«': 'e', 'Ã®': 'i',
  'Ã ': 'a', 'Ã¨': 'e', 'Ã¢': 'a',
  'Ú': 'e', 'ˆ': 'o', 'Ù': 'e', 'Û': 'e', 'Ü': 'e',
};

function repareerEncoding(s) {
  let r = s;
  Object.entries(ENCODING_MAP)
    .sort((a, b) => b[0].length - a[0].length)
    .forEach(([van, naar]) => { r = r.split(van).join(naar); });
  return r;
}

export function normNaamFase1(naam) {
  let n = naam || '';
  n = repareerEncoding(n);
  n = n.toLowerCase();
  n = n.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Komma-notatie omdraaien: "Achternaam, Voornaam" → "Voornaam Achternaam"
  const kommaMatch = n.match(/^([^,]+),\s*(.+)$/);
  if (kommaMatch) n = `${kommaMatch[2].trim()} ${kommaMatch[1].trim()}`;

  n = n.replace(/[''`]/g, '');
  n = n.replace(/-/g, ' ');
  n = n.replace(/\bv\.?\s*\/\s*d\.?\b/g, 'van der');
  n = n.replace(/\bv\.?d\.?\b/g, 'van der');
  n = n.replace(/\bvander\b/g, 'van der');
  n = n.replace(/\./g, '');
  n = n.replace(/\s+/g, ' ').trim();
  return n;
}

// Compacte versie zonder spaties — voor exacte string matching
export function normNaamCompact(naam) {
  return normNaamFase1(naam).replace(/\s+/g, '');
}
